import createClient from 'openapi-fetch';
import type { paths } from '../types/api.generated';
import { useAuth } from '@clerk/clerk-react';

const API_URL = (import.meta.env.VITE_API_URL) || 'http://localhost:8080/api/v1';

// Create the base client
export const apiClient = createClient<paths>({
  baseUrl: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Hook to add authentication to the client
export function useApiClient() {
  const { getToken } = useAuth();

  // Add auth interceptor
  apiClient.use({
    async onRequest({ request }) {
      try {
        const token = await getToken();
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      } catch (error) {
        console.error('Error getting auth token:', error);
      }
      return request;
    },
    // async onResponse({ response }) {
    //   if (response.status === 401) {
    //     // Token might be expired, redirect to sign-in
    //     window.location.href = '/sign-in';
    //   }
    //   return response;
    // },
  });

  return apiClient;
}

// Type helper for extracting data from API responses
export type ApiData<T> = T extends { data?: infer D } ? D : never;
export type ApiError<T> = T extends { error?: infer E } ? E : never;